(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aboutus-certificate"] && !Shopify.designMode) return;
  try {
    
/* No JS needed for the marquee. If you want to control speed from settings, set it via inline style: */
(function() {
  var root = document.querySelector('.essentials-section-{{ section.id }}');
  if (root) {
    root.style.setProperty('--marquee-speed', '{{ section.settings.marquee_speed }}s');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intersection-homepage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const sliderWrapper = document.querySelector('.fuel-slides-wrapper');
  const slides = document.querySelectorAll('.fuel-slide-uniq');
  const dotsContainer = document.querySelector('.slider-dots');

  let currentIndex = 0;
  const totalSlides = slides.length;

  // Create dots dynamically
  slides.forEach((_, index) => {
    const dot = document.createElement("button");
    if (index === 0) dot.classList.add("active");
    dot.addEventListener("click", () => {
      currentIndex = index;
      updateSliderPosition();
      updateDots();
    });
    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll("button");

  function updateSliderPosition() {
    sliderWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  function updateDots() {
    dots.forEach(dot => dot.classList.remove("active"));
    dots[currentIndex].classList.add("active");
  }

  function goToNext() {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSliderPosition();
    updateDots();
  }

  function goToPrev() {
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    updateSliderPosition();
    updateDots();
  }

  // Auto-slide every 6 seconds
  let autoSlide = setInterval(goToNext, 6000);

  // --- TOUCH SWIPE HANDLING ---
  let startX = 0;
  let endX = 0;

  sliderWrapper.addEventListener("touchstart", (e) => {
    clearInterval(autoSlide); // stop auto while swiping
    startX = e.touches[0].clientX;
  });

  sliderWrapper.addEventListener("touchmove", (e) => {
    endX = e.touches[0].clientX;
  });

  sliderWrapper.addEventListener("touchend", () => {
    let diff = startX - endX;
    if (Math.abs(diff) > 50) { 
      if (diff > 0) {
        goToNext(); // swipe left → next
      } else {
        goToPrev(); // swipe right → prev
      }
    }
    autoSlide = setInterval(goToNext, 6000); // restart auto
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mind360-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.swiper-container', {
      slidesPerView: 1.2,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const b3_panels = document.querySelectorAll(".right-accordion .accordion-item");
  b3_panels.forEach((b3_node) => {
    const b3_trigger = b3_node.querySelector(".accordion-toggle");
    const b3_marker = b3_node.querySelector(".accordion-icon");
    b3_trigger.addEventListener("click", () => {
      const b3_wasOpen = b3_node.classList.contains("active");
      b3_panels.forEach(b3_other => {
        b3_other.classList.remove("active");
        b3_other.querySelector(".accordion-icon").textContent = "+";
      });
      if (!b3_wasOpen) {
        b3_node.classList.add("active");
        b3_marker.textContent = "–";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section--accordion-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.accordion-item');

    items.forEach(item => {
      const answer = item.querySelector('.accordion-answer');
      if (item.classList.contains('active')) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });

    items.forEach(item => {
      const question = item.querySelector('.accordion-question');
      const answer = item.querySelector('.accordion-answer');

      question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');


        items.forEach(i => {
          const a = i.querySelector('.accordion-answer');
          if (i !== item) {
            i.classList.remove('active');
            a.style.maxHeight = null;
          }
        });


        if (isActive) {
          item.classList.remove('active');
          answer.style.maxHeight = null;
        } else {
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
